import { css } from "@emotion/react";
import theme from "src/theme";

const sharedButtonStyle = `
  flex: 1;
  display: flex;
  font-size: 0.9rem;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 0;
  padding: 0;
  background-color: ${theme.colors.white};
  font-family: ${theme.fonts.sofiaPro};
  font-weight: bold;
  border: 0;

  :first-of-type {
    border-right: 1px solid ${theme.colors.background.veryLightGray};
  }
`;

export default {
  drawerContentContainer: css`
    padding: 1rem 1rem 0 1rem;
    min-height: 220px;

    .ant-form-item-explain.ant-form-item-explain-error {
      padding-top: 0.4375rem;
      padding-left: 0.125rem;
      font-size: 16px;
    }
  `,
  drawerInfoContainer: css`
    margin-bottom: 1.5rem;
  `,
  addClientHeaderText: css`
    color: ${theme.colors.secondary.navyBlue} !important;
    font-size: 1.2rem !important;
    padding-bottom: 0.625rem;
    padding-top: 0.625rem;
  `,
  drawerHeader: css`
    color: ${theme.colors.secondary.navyBlue} !important;
    font-size: 1rem !important;
    font-weight: 600 !important;
    margin-bottom: 0 !important;

    :first-of-type {
      margin-top: 1rem;
    }
  `,
  drawerButtonContainer: css`
    height: 50px;
    margin-left: -1rem;
    margin-right: -1rem;
    background-color: ${theme.colors.white};
    display: flex;
    border-top: 1px solid ${theme.colors.background.veryLightGray};
  `,
  mobileButtonContainer: css`
    ${sharedButtonStyle}
  `,
  mobileButtonContainerPrimary: css`
    ${sharedButtonStyle}
    color: ${theme.colors.white};
    background-color: ${theme.colors.primary.blue};
  `,
  mobileButtonContainerCancel: css`
    ${sharedButtonStyle}
    color: ${theme.colors.primary.blue};
  `,
  iconContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.5rem;
  `,
  drawerTextContainer: css`
    text-align: center;
    line-height: 1;
    margin-top: -0.9375rem;
    margin-bottom: 1.875rem;
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  `,
  drawerText: css`
    font-size: 0.75rem;
    color: ${theme.colors.background.darkGray};
  `,
  selectInput: css`
    color: transparent;
  `,
  selectClear: css`
    .ant-select-clear {
      font-size: 0.9375rem !important;
      right: 0.75rem !important;
    }
  `,
};
